const PERMISSIONS_KEY = 'permissions'

const setUserPermissions = (permissions) => {
    sessionStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions))
}

const getUserPermissions = () => JSON.parse(sessionStorage.getItem(PERMISSIONS_KEY))

const removeUserPermissions = () => sessionStorage.removeItem(PERMISSIONS_KEY)

const userHasAuthToModifyTarget = ({
    currentUserIsAdmin,
    currentUserIsGod,
    currentUserIsLocalAdmin,
    currentUserIsTargetMaster,
}) => {
    return currentUserIsAdmin || currentUserIsGod || currentUserIsLocalAdmin || currentUserIsTargetMaster
}

export { setUserPermissions, getUserPermissions, removeUserPermissions, userHasAuthToModifyTarget }
